import { render, staticRenderFns } from "./PromoCategoryTable.vue?vue&type=template&id=339a2414&scoped=true&"
import script from "./PromoCategoryTable.vue?vue&type=script&lang=js&"
export * from "./PromoCategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339a2414",
  null
  
)

export default component.exports